<template>
  <div class="storeCouponsRecord">
    <!-- 商家发券使用记录页：沿用发券记录页的列表结构，切换为使用记录接口与字段展示。 -->
    <el-card>
      <div class="jump-btn">
        <el-button type="primary" @click="jump">{{ $t('lang.btn_backpage') }}</el-button>
      </div>

      <!-- 查询区仅保留车牌号模糊搜索，请求时固定带上 couponMerchantId。 -->
      <div class="filters">
        <el-form :inline="true">
          <el-form-item>
            <el-input
              v-model.trim="carNum"
              placeholder="请输入车牌号"
              clearable
              @keyup.enter.native="submit"
            ></el-input>
          </el-form-item>
          <el-button type="primary" @click="submit">{{ $t('lang.btn_search') }}</el-button>
        </el-form>
      </div>

      <!-- 列表走服务端分页；时长券显示减免时长，次数券显示减免次数。 -->
      <el-table
        :data="tableData"
        class="wid100"
        :height="
          tableData.length > 0
            ? require('@/config/enum').tableheight529
            : require('@/config/enum').tableheight109
        "
        :row-class-name="tableRowClassName"
      >
        <el-table-column
          type="index"
          :index="indexMethod"
          align="center"
          :label="$t('lang.lab_index')"
          width="100px"
        ></el-table-column>
        <el-table-column label="车牌号码">
          <template slot-scope="scope">
            <span>{{ getCarNum(scope.row) | valueIsNull }}</span>
          </template>
        </el-table-column>
        <el-table-column label="券名称">
          <template slot-scope="scope">
            <span>{{ getCouponName(scope.row) | valueIsNull }}</span>
          </template>
        </el-table-column>
        <el-table-column label="券类型">
          <template slot-scope="scope">
            <span v-if="Number(getCouponType(scope.row)) === 1">时长减免</span>
            <span v-else-if="Number(getCouponType(scope.row)) === 2">次数减免</span>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column label="减免时长">
          <template slot-scope="scope">
            <span v-if="Number(getCouponType(scope.row)) === 1">{{ getReduceMinutes(scope.row) }}</span>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column label="减免次数">
          <template slot-scope="scope">
            <span v-if="Number(getCouponType(scope.row)) === 2">{{ getReduceCount(scope.row) }}</span>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column label="车场">
          <template slot-scope="scope">
            <span>{{ getParkName(scope.row) | valueIsNull }}</span>
          </template>
        </el-table-column>
        <el-table-column label="使用时间" width="180">
          <template slot-scope="scope">
            <span v-if="getUseTime(scope.row)">{{ getUseTime(scope.row) | time }}</span>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column label="备注">
          <template slot-scope="scope">
            <span>{{ getRemark(scope.row) | valueIsNull }}</span>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNo"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pageSize"
        layout="sizes, prev, pager, next, jumper"
        :page-count="pageCount"
      />
    </el-card>
  </div>
</template>

<script>
// 商家发券使用记录页：根据券 ID 查询使用记录，支持按车牌号模糊搜索。
export default {
  name: '/manage/main.storeCouponsRecord',
  data() {
    return {
      couponMerchantId: '',
      carNum: '',
      pageNo: 1,
      pageSize: 10,
      pageCount: 0,
      tableData: [],
    }
  },
  created() {
    this.initPage()
  },
  watch: {
    $route() {
      this.initPage()
    },
  },
  methods: {
    // 读取路由里的券 ID，缺参时拦截空请求。
    initPage() {
      this.couponMerchantId = this.$route.query.couponMerchantId || this.$route.query.id || ''
      this.carNum = ''
      this.pageNo = 1
      this.pageCount = 0
      this.tableData = []
      if (!this.couponMerchantId) {
        this.$message.warning('缺少券ID参数')
        return
      }
      this.getTableList()
    },
    indexMethod(index) {
      return (this.pageNo - 1) * this.pageSize + index + 1
    },
    tableRowClassName({ rowIndex }) {
      return rowIndex % 2 === 0 ? 'row-dark' : ''
    },
    // 使用记录列表走服务端分页，请求参数与项目其他列表保持一致。
    getTableList() {
      if (!this.couponMerchantId) {
        return
      }
      let loading = this.$loading()
      this.$get(
        `/carCouponMerchantRecord?couponMerchantId=${this.couponMerchantId}&carNum=${this.carNum || ''}&pageNo=${this.pageNo}&pageSize=${this.pageSize}`
      ).then(
        res => {
          loading.close()
          if (res && res.errCode === 0) {
            const payload = res.data && typeof res.data === 'object' ? res.data : res
            if (Array.isArray(payload.list)) {
              this.tableData = payload.list
            } else if (Array.isArray(res.list)) {
              this.tableData = res.list
            } else if (Array.isArray(payload)) {
              this.tableData = payload
            } else if (Array.isArray(res)) {
              this.tableData = res
            } else {
              this.tableData = []
            }
            this.pageCount = Number(payload.pageCount || res.pageCount || 0)
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    submit() {
      this.pageNo = 1
      this.getTableList()
    },
    handleCurrentChange(val) {
      this.pageNo = val
      this.getTableList()
    },
    handleSizeChange(val) {
      this.pageNo = 1
      this.pageSize = val
      this.getTableList()
    },
    // 兼容使用记录平铺返回，或券信息嵌套在对象里。
    getValueByPaths(row, paths, defaultValue = '') {
      for (let i = 0; i < paths.length; i++) {
        const keys = paths[i].split('.')
        let current = row
        let valid = true
        for (let j = 0; j < keys.length; j++) {
          if (current === null || current === undefined || current[keys[j]] === undefined) {
            valid = false
            break
          }
          current = current[keys[j]]
        }
        if (valid && current !== '' && current !== null && current !== undefined) {
          return current
        }
      }
      return defaultValue
    },
    getCarNum(row) {
      return this.getValueByPaths(row, ['carNum'])
    },
    getCouponName(row) {
      return this.getValueByPaths(row, ['couponName', 'carCouponMerchant.couponName'])
    },
    getCouponType(row) {
      return this.getValueByPaths(row, ['couponType', 'carCouponMerchant.couponType'], '')
    },
    getReduceMinutes(row) {
      return this.getValueByPaths(row, ['reduceMinutes', 'carCouponMerchant.reduceMinutes'], 0)
    },
    getReduceCount(row) {
      return this.getValueByPaths(
        row,
        [
          'reduceCount',
          'count',
          'couponCount',
          'reduceTimes',
          'times',
          'carCouponMerchant.reduceCount',
          'carCouponMerchant.count',
          'carCouponMerchant.couponCount',
          'carCouponMerchant.reduceTimes',
        ],
        1
      )
    },
    getParkName(row) {
      return this.getValueByPaths(
        row,
        ['parkName', 'carPark.parkName', 'carCouponMerchant.carPark.parkName']
      )
    },
    getUseTime(row) {
      return this.getValueByPaths(row, ['useTime', 'createTime', 'updateTime'], '')
    },
    getRemark(row) {
      return this.getValueByPaths(row, ['remark', 'carCouponMerchant.remark'])
    },
    jump() {
      this.$router.go(-1)
    },
  },
}
</script>

<style lang="scss">
.storeCouponsRecord {
  .wid100 {
    width: 100%;
  }

  .jump-btn {
    margin-bottom: 15px;
  }

  .filters {
    margin-bottom: 15px;
  }
}
</style>
